import { isSubscriptionMember } from "helpers/membership-helpers";
import { discoProgramEligibility, nextGridProgramEligibility } from "rtr-constants";
import PropTypes from "prop-types";

export function userNotEligibleForProduct(staticProduct, membershipState, userData) {
  const programEligibilityOfProduct = staticProduct?.programEligibility;
  const inventoryEligibilitiesOfMember = membershipState?.inventoryEligibilities;
  // @TODO: Uncomment isSubscriptionLens when lenses are added to universal PDP

  // isSubscriptionLens(userData) &&
  return (
    isSubscriptionMember(userData) &&
    nextGridProgramEligibility[inventoryEligibilitiesOfMember?.[0]] === nextGridProgramEligibility.rtr_update &&
    !programEligibilityOfProduct.includes(discoProgramEligibility.rtr_update)
  );
}

export default function ProgramEligibilityNotification({ userNotEligibleForProduct }) {
  if (userNotEligibleForProduct) {
    return (
      <>
        <p className="mt-8 text-md font-bold mb-2">This item is not included in your Basic Closet plan.</p>
        <div className="inline-block">
          <p className="text-md">To access premium inventory, </p>&nbsp;
          <a className="font-medium underline" href="/user/settings/managePlan">
            Add a Shipment.
          </a>
        </div>
      </>
    );
  }

  return;
}

ProgramEligibilityNotification.propTypes = {
  userNotEligibleForProduct: PropTypes.bool,
};
